const topics = [
  { name: '韩漫推荐', count: '2.3k', color: 'accent' },
  { name: '日漫连载', count: '1.8k', color: 'primary' },
  { name: '国漫新作', count: '956', color: 'secondary' },
  { name: '热血战斗', count: '3.2k', color: 'accent' },
  { name: '恋爱甜宠', count: '2.7k', color: 'primary' },
  { name: '下拉式漫画', count: '1.5k', color: 'secondary' },
  { name: '悬疑推理', count: '890', color: 'accent' },
  { name: '奇幻冒险', count: '2.1k', color: 'primary' },
  { name: '免费全集', count: '4.5k', color: 'secondary' },
  { name: '耽美百合', count: '1.2k', color: 'accent' },
];

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">探索当前最热漫画话题，发现更多精彩内容与同好交流</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.name}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors ${colorMap[topic.color]}`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}